<template>
  <div class="container-fluid">
    <div class="card search-card">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <div class="form-row">
            <!-- 面談日期 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">面談日期</label>
                <ValidationProvider
                  :rules="{ dateRangeRequired: true }"
                  v-slot="{ errors }"
                >
                  <el-date-picker
                    class="w-100"
                    type="daterange"
                    :clearable="false"
                    :picker-options="{
                      disabledDate: $common.disabledDateAfterToday,
                    }"
                    range-separator="-"
                    start-placeholder="開始日期"
                    end-placeholder="結束日期"
                    v-model="interviewDateRange"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <!-- 需求單位 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">需求單位</label>
                <el-input
                  clearable
                  placeholder="請輸入關鍵字"
                  v-model.trim="searchCondition.applicantDepartment"
                />
              </div>
            </div>
            <!-- 單位面試主管 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">單位面試主管</label>
                <el-select
                  class="w-100"
                  value-key="Guid"
                  filterable
                  placeholder="請選擇"
                  v-model="searchCondition.InterviewSupervisor"
                >
                  <el-option
                    v-for="supervisor in supervisorOptions"
                    :key="supervisor.Guid"
                    :label="supervisor.Name"
                    :value="supervisor.Name"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- HR 面試人員 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">HR 面試人員</label>
                <el-select
                  class="w-100"
                  filterable
                  clearable
                  placeholder="請選擇"
                  v-model="searchCondition.InterviewHR"
                >
                  <el-option
                    v-for="supervisor in supervisorOptions"
                    :key="supervisor.Guid"
                    :label="supervisor.Name"
                    :value="supervisor.Name"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- 職缺編號 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">職缺編號</label>
                <el-input
                  clearable
                  placeholder="請輸入關鍵字"
                  v-model.trim="searchCondition.manpowerDemandNo"
                />
              </div>
            </div>
            <!-- 職缺名稱 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">職缺名稱</label>
                <el-input
                  clearable
                  placeholder="請輸入關鍵字"
                  v-model.trim="searchCondition.manpowerDemandName"
                />
              </div>
            </div>

            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="interviewee">應聘者</label>
                <el-input
                  clearable
                  placeholder="請輸入關鍵字"
                  v-model.trim="searchCondition.interviewee"
                />
              </div>
            </div>

            <div class="col-sm-12 col-md-3">
              <button
                type="button"
                class="btn btn-primary"
                style="margin-top: 30px"
                @click="
                  (currentPage = 1),
                    handleSubmit(getInterviewed)
                "
              >
                查詢
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                style="margin-top: 30px; margin-left: 10px"
                @click="
                  searchCondition = {};
                  interviewDateRange = [
                    new Date(dayjs().subtract(7, 'day').format('YYYY-MM-DD')),
                    new Date($common.getToday()),
                  ];
                "
              >
                清除
              </button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="personList.length > 0">
      <span class="mr-2">共計：{{ totalPerson }}人</span>
      <CardStyle @changeStyle="changeStyle" />
    </div>

    <!-- 人員卡片 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard ref="personCard" :showCheckbox="false" :person="person">
          <template v-slot:tag="{ props }">
            <div class="result">{{ props.ApprovalResult }}</div>
          </template>

          <template v-slot:middleContent="{ props }">
            <table>
              <tr>
                <th>職缺名稱</th>
                <td>{{ props.ManpowerDemandName }}</td>
              </tr>
              <tr>
                <th>應徵職務</th>
                <td>{{ props.Position }}</td>
              </tr>
              <tr>
                <th>面談時間</th>
                <td>{{ $common.dateFormatter(props.InterviewDate) }}</td>
              </tr>
              <tr>
                <th>面談地點</th>
                <td>{{ props.InterviewPlace }}</td>
              </tr>
              <tr>
                <th>單位面試主管</th>
                <td>{{ props.InterviewSupervisor[0] }}</td>
              </tr>
              <tr>
                <th>HR 面試人員</th>
                <td>{{ props.InterviewHR[0] }}</td>
              </tr>
            </table>
          </template>

          <template v-slot:buttonGroup="{ props }">
            <el-dropdown>
              <button type="button" class="el-dropdown-link">
                檢視資訊<i class="el-icon-arrow-down el-icon--right"></i>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="showDetailModal(props)">
                  檢視履歷
                </el-dropdown-item>
                <el-dropdown-item @click.native="showProgressRecord(props)">
                  檢視歷程
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <button type="button" @click="clickReinvite(props)">
              重新邀約
            </button>
            <button
              type="button"
              @click="getInterviewRecordHistory(props.MatchId)"
            >
              面談紀錄歷程
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 分頁 -->
    <el-pagination
      v-if="personList.length > 0"
      background
      layout="prev, pager, next"
      :total="totalPerson"
      :page-size="9"
      @current-change="changePage"
    >
    </el-pagination>

    <!-- 面談未到 Modal -->
    <div
      class="modal fade"
      id="declineInterviewReasonModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <span>面談未到</span>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <textarea
                type="text"
                rows="5"
                class="form-control"
                placeholder="請輸入原因"
                v-model="personData.reason"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="saveDeclineInterviewReason"
            >
              {{ i18n("Buttons.Save") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 重新邀約 -->
    <ReinviteMailModal :personData="personData" @updatePerson="updatePerson" />

    <!-- 面談紀錄歷程 Modal -->
    <div
      class="modal fade"
      id="interviewRecordHistoryModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <span>面談紀錄歷程</span>
          </div>
          <div class="modal-body">
            <ValidationObserver v-slot="{ handleSubmit }">
              <div class="d-flex align-items-start" style="margin-bottom: 10px">
                <ValidationProvider
                  ref="addInterviewSupervisor"
                  class="w-100"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <multiselect
                    :options="supervisorOptions"
                    :close-on-select="false"
                    multiple
                    tagPlaceholder=""
                    selectLabel=""
                    selectedLabel=""
                    deselectLabel=""
                    label="Name"
                    track-by="Guid"
                    placeholder="請選擇加簽人員"
                    v-model="InterviewSupervisor"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
                <button
                  class="btn btn-primary"
                  style="margin: 2px 0 0 10px; width: 70px"
                  @click="handleSubmit(addInterviewRecord)"
                >
                  加簽
                </button>
              </div>
            </ValidationObserver>
            <div class="evaluation-person-info">
              <div>
                <label for="">姓名</label>
                <div>{{ recordList.Interviewee }}</div>
              </div>

              <div>
                <label for="">面談日期</label>
                <div
                  v-for="(date, index) in recordList.InterviewDateList"
                  :key="index"
                >
                  {{ $common.dateTimeFormatter(date) }}
                </div>
              </div>

              <div v-for="score in recordList.Scores" :key="score.Seq">
                <label for="">{{ score.Name }}</label>
                <div>{{ score.OriginScore }}/{{ score.Score }}</div>
              </div>

              <span
                style="
                  position: absolute;
                  right: 5px;
                  bottom: 2px;
                  color: #ffffff;
                  z-index: 2;
                  font-size: 0.9em;
                "
              >
                最後更新者：{{ recordList.UpdateUser }}
              </span>
            </div>
            <template
              v-if="
                recordList.InterviewRecords &&
                recordList.InterviewRecords.length > 0
              "
            >
              <div style="display: flex; margin-top: 2px">
                <div class="evaluation-body fixed">
                  <div
                    class="evaluation-name"
                    style="height: 60px; line-height: 50px"
                  >
                    單位面試主管
                  </div>
                  <div
                    v-for="(item, index) in recordList.InterviewRecords[0]
                      .InterviewRecordAppraisals"
                    :key="index"
                    class="evaluation-field"
                  >
                    {{ item.Name }}
                  </div>

                  <template v-if="recordList.ResumeType === 'IDL'">
                    <div class="evaluation-field">職等</div>
                  </template>

                  <div
                    class="evaluation-field"
                    style="height: 150px; overflow-y: auto"
                  >
                    面談說明
                  </div>

                  <div
                    class="evaluation-field"
                    style="height: 150px; overflow-y: auto"
                  >
                    個人備註
                  </div>
                  <div class="evaluation-field">面談結果</div>

                  <template v-if="recordList.ResumeType === 'IDL'">
                    <div class="evaluation-field">是否已進行風險評估</div>
                  </template>

                  <div class="evaluation-field" style="height: 42px" />
                </div>

                <div style="flex: 1; min-width: 1px">
                  <carousel
                    :key="Math.random()"
                    :items="recordList.InterviewRecords.length"
                    :nav="true"
                    :dots="false"
                  >
                    <div
                      v-for="(record, index) in recordList.InterviewRecords"
                      class="evaluation-body"
                      :key="index"
                      @dblclick="$common.copyText($event)"
                    >
                      <div class="evaluation-name" style="height: 60px">
                        【{{ record.InterviewTitle }}】<br />
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="
                            record.InterviewSupervisor +
                            ' (' +
                            record.InterviewUserType +
                            ')'
                          "
                          placement="right"
                        >
                          <span>
                            {{ record.InterviewSupervisor }} ({{
                              record.InterviewUserType
                            }})
                          </span>
                        </el-tooltip>
                      </div>

                      <div
                        v-for="(
                          item, index
                        ) in record.InterviewRecordAppraisals"
                        class="evaluation-field"
                        :key="index"
                      >
                        <template
                          v-if="item.Result !== '-' && item.Result !== '未填寫'"
                        >
                          <el-tooltip
                            v-if="item.Remark"
                            class="item"
                            effect="dark"
                            :content="item.Remark"
                            placement="right"
                          >
                            <span>
                              {{ item.Result }}
                            </span>
                          </el-tooltip>
                          <span v-else>{{ item.Result }}</span>
                        </template>
                        <span v-else>{{ item.Result }}</span>
                      </div>

                      <template v-if="recordList.ResumeType === 'IDL'">
                        <!-- 職等 -->
                        <div class="evaluation-field">
                          {{ record.ExpectedJobLevel }}
                        </div>
                      </template>

                      <!-- 面談備註 -->
                      <div
                        class="evaluation-field"
                        style="height: 150px; overflow-y: auto"
                      >
                        <div>
                          {{ record.Remark }}
                        </div>
                      </div>
                      <!-- 個人備註 -->
                      <div
                        class="evaluation-field"
                        style="height: 150px; overflow-y: auto"
                      >
                        <div>
                          {{ record.PersonalRemark }}
                        </div>
                      </div>
                      <!-- 面談結果 -->
                      <div class="evaluation-field">
                        <div>
                          {{ record.InterviewResult }}
                        </div>
                      </div>
                      <!-- 是否已進行風險評估 -->
                      <div v-if="recordList.ResumeType === 'IDL'" class="evaluation-field">
                        <div v-if="record.InterviewResult === '未填寫'">
                          未填寫
                        </div>
                        <div v-else>
                          已完成評估
                        </div>
                      </div>

                      <div class="evaluation-field" style="height: 42px">
                        <button
                          v-if="record.InterviewResult === '未填寫'"
                          class="btn btn-warning btn-sm"
                          @click="
                            interviewRecordUrge(record.InterviewSupervisorId)
                          "
                        >
                          催辦
                        </button>
                        <div v-else>已填寫面談紀錄</div>
                      </div>
                    </div>
                  </carousel>
                </div>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="getApproveInterview(recordList)"
            >
              完成面談評估
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 面談評估 Modal -->
    <EvaluateInterviewModal
      :Source="'Interviewed'"
      :AdmitOptions="admitOptions"
      :IdlRejectOptions="idlRejectOptions"
      :DlRejectOptions="dlRejectOptions"
      :Person="personData"
      @saveApproveInterview="saveApproveInterview"
    />

    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF" />
                履歷
              </span>
            </a>
            <div
              class="close-show-detail"
              @click="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              />
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>

    <!-- 檢視歷程 -->
    <ProgressRecordModal :Name="Name" :UserId="UserId" :Email="Email" />
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import carousel from "vue-owl-carousel2";
import Logo from "@/components/company/Logo.vue";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 卡片樣式
import CardStyle from "@/components/back/Card/CardStyle";
// 重新邀約
import ReinviteMailModal from "@/components/back/Modal/ReinviteMail";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 面談評估
import EvaluateInterviewModal from "@/components/back/Modal/EvaluateInterview";
// 歷程
import ProgressRecordModal from "@/views/back/TalentQuery/ResultPage/Modal/ProgressRecord";

export default {
  name: "Progress_Interviewed",

  components: {
    carousel,
    Logo,
    PersonCard,
    CardStyle,
    ReinviteMailModal,
    IdlResume,
    DlResume,
    EvaluateInterviewModal,
    ProgressRecordModal,
  },
  data() {
    return {
      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // 查詢條件
      interviewDateRange: [],
      searchCondition: {},
      supervisorOptions: [],

      // 檢視資訊
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeType: null, // 履歷種類

      // 人員圖卡列表
      personList: [],
      // 人員資料
      personData: {},

      // 面談評估 Modal
      admitOptions: [], // 錄取[備註]選項
      idlRejectOptions: [], // idl-不錄取[原因]選項
      dlRejectOptions: [], // dl-不錄取[原因]選項

      // 面談紀錄歷程
      recordList: {},

      // 加簽人員列表
      InterviewSupervisor: [],

      // 分頁
      totalPerson: 0, // 共幾筆
      currentPage: 1, // 當前第幾頁

      // 檢視歷程
      Name: null,
      UserId: null,
      Email: null,
    };
  },

  methods: {
    // 面談結果列表 API
    getInterviewed() {
      this.updateLoading(true);
      this.$store.commit("ScrollTop", true);

      this.$api.hr
        .getInterviewedPaging({
          ...this.searchCondition,
          interviewDateStart: this.interviewDateRange
            ? this.$common.dateFormatter(this.interviewDateRange[0])
            : null,
          interviewDateEnd: this.interviewDateRange
            ? this.$common.dateFormatter(this.interviewDateRange[1])
            : null,
          Page: this.currentPage,
          PerPage: 9,
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.Quantity > 0) {
              this.totalPerson = response.data.Quantity;
              this.personList = response.data.Datas;
              this.$store.commit("ScrollTop", false);
            }
          }
          this.updateLoading(false);
        });
    },

    // 換頁
    changePage(page) {
      this.currentPage = page;
      this.getInterviewed();
    },

    // 重新邀約
    clickReinvite(person) {
      this.personData = person;
      this.$store.commit("OpenReinviteMailModal", true);
    },

    // 更新卡片
    updatePerson() {
      this.currentPage = 1;
      this.getInterviewed();
    },

    // 面談未到 API
    saveDeclineInterviewReason() {
      const vm = this;
      const api = `${window.endpoints.api}/Recruitment/InterviewNotArrived`;

      const data = {
        MatchId: vm.personData.matchId,
        Reason: vm.personData.reason,
      };

      $("#declineInterviewReasonModal").modal("hide");

      this.updateLoading(true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            this.updateLoading(false);

            vm.personList.forEach((item, index, arr) => {
              if (item.MatchId === data.matchid) {
                arr.splice(index, 1);
              }
            });

            vm.$notify({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 2500,
            });
          }
        })
        .catch((error) => {
          this.updateLoading(false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 取得面談評估
    getApproveInterview(props) {
      this.personData = props;
      this.$store.commit("OpenEvaluateInterviewModal", true);
    },

    // 完成面談評估
    saveApproveInterview(params) {
      this.$store.commit("OpenEvaluateInterviewModal", false);
      this.updateLoading(true);

      this.$api.approveInterview
        .putApproveInterview(params)
        .then((response) => {
          if (response.status === 200) {
            this.personList.forEach((item, index, arr) => {
              if (item.InterviewId === this.recordList.InterviewId) {
                arr.splice(index, 1);
              }
            });
            this.$notify({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 2500,
            });
          }
          this.updateLoading(false);
        });
    },

    // 取得 面談紀錄歷程(HR)
    getInterviewRecordHistory(MatchId) {
      this.updateLoading(true);

      this.MatchId = MatchId;
      this.InterviewSupervisor = [];
      this.$refs.addInterviewSupervisor.reset();

      this.$api.approveInterview
        .getInterviewRecordForHr(this.MatchId)
        .then((response) => {
          if (response.status === 200) {
            this.recordList = response.data;
          }
          this.updateLoading(false);
          $("#interviewRecordHistoryModal").modal("show");
        });
    },

    // 加簽 API
    addInterviewRecord() {
      const vm = this;
      const api = `${window.endpoints.api}/Recruitment/AddInterviewRecord`;

      const data = {
        InterviewId: vm.recordList.InterviewId,
        InterviewSupervisor: vm.InterviewSupervisor.map(
          (element) => element.Guid
        ),
        CreateUser: vm.$cookies.get("userName"),
      };

      this.updateLoading(true);
      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            this.updateLoading(false);

            vm.personList.forEach((item, index, arr) => {
              if (item.InterviewId === data.InterviewId) {
                arr[index].InterviewSupervisor = vm.InterviewSupervisor.map(
                  (element) => element.Name
                );
              }
            });

            vm.$notify({
              title: "成功",
              message: "加簽成功",
              type: "success",
              duration: 2500,
            });

            vm.getInterviewRecordHistory(vm.MatchId);
          }
        })
        .catch((error) => {
          this.updateLoading(false);
          vm.$notify({
            title: "加簽失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 催辦 API
    interviewRecordUrge(supervisor) {
      const vm = this;
      const api = `${window.endpoints.api}/Recruitment/InterviewRecordUrge`;

      const data = {
        InterviewId: vm.recordList.InterviewId,
        InterviewSupervisor: supervisor,
      };

      this.updateLoading(true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            this.updateLoading(false);
            vm.$notify({
              title: "成功",
              message: "已寄出催辦信件",
              type: "success",
              duration: 2500,
            });
          }
        })
        .catch((error) => {
          this.updateLoading(false);
          vm.$notify({
            title: "催辦失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 檢視資訊 Modal
    showDetailModal(person) {
      this.MatchId = person.MatchId;
      this.ResumeId = person.ResumeId;
      this.ResumeType = person.ResumeType;
      this.isShowDetail = true;
    },

    // 檢視歷程
    showProgressRecord(person) {
      this.MatchId = person.Id;
      this.Name = person.Name;
      this.UserId = person.UserId;
      this.Email = person.Email;
      this.$store.commit("OpenCandidateProcessModal", true);
    },

    // 卡片樣式
    changeStyle(style) {
      this.gridStyle = style;
    },

    async getData() {
      try {
        // 取得錄取的[備註]下拉選單
        const admit = await this.$api.recruitment.getInterviewBasicCondition();
        // 取得idl不錄取的[原因]下拉選單
        const idl = await this.$api.recruitment.getInterviewNotAdmitReason({
          ResumeType: "IDL",
          IsNotAdmitReason: true,
        });
        // 取得dl不錄取的[原因]下拉選單
        const dl = await this.$api.recruitment.getInterviewNotAdmitReason({
          ResumeType: "DL",
          IsNotAdmitReason: true,
        });

        // 取得 主管列表
        const backgroundUser =
          await this.$api.backgroundUser.getBackgroundUser();
        this.admitOptions = admit.data;
        this.idlRejectOptions = idl.data;
        this.dlRejectOptions = dl.data;
        this.supervisorOptions = backgroundUser.data.map((user) => {
          return {
            Guid: user.UserId,
            Name: user.Name,
          };
        });
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message + "請聯繫系統管理員",
          type: "error",
          duration: 0,
        });
      }
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  watch: {
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },
  },

  created() {
    const lastWeek = this.dayjs().subtract(7, "day").format("YYYY-MM-DD"); // 前一個禮拜
    this.interviewDateRange = [
      new Date(lastWeek),
      new Date(this.$common.getToday()),
    ];
    // 取得已面談
    this.getInterviewed();
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
/deep/ input[placeholder="Go to page"] {
  display: none;
}
</style>
